import { render, staticRenderFns } from "./LoginAgree.vue?vue&type=template&id=485fc6d6&scoped=true&"
import script from "./LoginAgree.vue?vue&type=script&lang=js&"
export * from "./LoginAgree.vue?vue&type=script&lang=js&"
import style0 from "./LoginAgree.vue?vue&type=style&index=0&id=485fc6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485fc6d6",
  null
  
)

export default component.exports